// extracted by mini-css-extract-plugin
module.exports = {"inputForm":"ContactForm_inputForm__3PADU"};